<ion-header>
  <ion-toolbar color="primary">
    <ion-title color="light20">Adjust Missed Punch</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-card color="light20">
    <ion-item>
      <ion-label position="stacked">In Date/Time:</ion-label>
      <ion-text>{{ min | date: 'EEE MMM d, y h:mm a' }}</ion-text>
    </ion-item>
    <ion-item>
      <ion-text>Select your correct Out Date/Time:</ion-text>
    </ion-item>
    <ion-item>
      <mbsc-datepicker
        display="inline"
        [controls]="['datetime']"
        [touchUi]="true"
        [min]="min"
        [max]="max"
        [(ngModel)]="value"
        (ngModelChange)="isDirty = true"
      >
      </mbsc-datepicker>
    </ion-item>
    <ion-item *ngIf="split">
      <p>
        <i
          >NOTE: If your punch crosses a time sheet period, it will be split into separate punches for each time
          period.</i
        >
      </p>
    </ion-item>
  </ion-card>
</ion-content>

<ion-toolbar color="primary">
  <ion-buttons slot="end">
    <ion-button color="light40" fill="solid" (click)="closePopover('cancel')">
      <ion-text color="warning">Cancel</ion-text>
      <ion-icon color="warning" slot="start" name="arrow-undo-circle-outline"></ion-icon>
    </ion-button>
    <ion-button color="light40" fill="solid" [disabled]="!isDirty" (click)="closePopover('save')">
      <ion-text color="success"><b>Set</b></ion-text>
      <ion-icon color="success" slot="start" name="save-outline"></ion-icon>
    </ion-button>
  </ion-buttons>
</ion-toolbar>
